type UsageCountItem = {
    count: number;
};

type UsageCallback = (items: UsageCountItem[]) => void;

export const cookingStepDeleteService = {
    getWhereItemIsUsed(_itemId: string, callback?: UsageCallback): void {
        if (callback) {
            callback([]);
        }
    },
    getTranslationCode(): string {
        return '';
    },
    checkIsDeletedItem(): boolean {
        return false;
    },
};
